export function isFirefox() {
  return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
}